export class APIInfo {
  webApiToken: string;
  webApiBaseUrl: string;
  coolSecurityToken: string;
  role: string;
}
